import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ButtonKinds } from 'carbon-components-react/lib/prop-types/types';
import { IlButton } from '../../IlButton/index.js';
import { IlTooltipTippy } from '../../IlTooltipTippy/index.js';
import { FW_PREFIX } from '../../../shared/constants/generalConstants.js';

var IlModalFooterV2 = /*#__PURE__*/function (_Component) {
  function IlModalFooterV2() {
    _classCallCheck(this, IlModalFooterV2);
    return _callSuper(this, IlModalFooterV2, arguments);
  }
  _inherits(IlModalFooterV2, _Component);
  return _createClass(IlModalFooterV2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        modalFooterV2ClassName = _this$props.modalFooterV2ClassName,
        primaryButtonText = _this$props.primaryButtonText,
        primaryButtonId = _this$props.primaryButtonId,
        secondaryButtonText = _this$props.secondaryButtonText,
        secondaryButtonId = _this$props.secondaryButtonId,
        tertiaryButtonText = _this$props.tertiaryButtonText,
        tertiaryButtonId = _this$props.tertiaryButtonId,
        primaryButtonClick = _this$props.primaryButtonClick,
        primaryButtonDisabled = _this$props.primaryButtonDisabled,
        secondaryButtonClick = _this$props.secondaryButtonClick,
        secondaryButtonDisabled = _this$props.secondaryButtonDisabled,
        tertiaryButtonClick = _this$props.tertiaryButtonClick,
        tertiaryButtonKind = _this$props.tertiaryButtonKind,
        tertiaryButtonDisabled = _this$props.tertiaryButtonDisabled,
        danger = _this$props.danger,
        primaryButtonTooltipText = _this$props.primaryButtonTooltipText;
      var buttonKind = danger ? 'danger' : 'primary';
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, primaryButtonText && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: classNames("".concat(modalFooterV2ClassName), "".concat(modalFooterV2ClassName, "-desktop"), "".concat(FW_PREFIX, "__IlModalFooterV2"))
      }, tertiaryButtonText && /*#__PURE__*/React__default.createElement(IlButton, {
        className: classNames("".concat(FW_PREFIX, "__IlModalFooterV2-tertiary-button"), "".concat(FW_PREFIX, "__IlModalFooterV2-footer-button")),
        onClick: tertiaryButtonClick,
        kind: tertiaryButtonKind || "secondary",
        id: tertiaryButtonId,
        disabled: tertiaryButtonDisabled
      }, tertiaryButtonText), secondaryButtonText && /*#__PURE__*/React__default.createElement(IlButton, {
        className: classNames("".concat(FW_PREFIX, "__IlModalFooterV2-secondary-button"), "".concat(FW_PREFIX, "__IlModalFooterV2-footer-button")),
        onClick: secondaryButtonClick,
        kind: "secondary",
        id: secondaryButtonId,
        disabled: secondaryButtonDisabled
      }, secondaryButtonText), /*#__PURE__*/React__default.createElement(IlButton, {
        className: classNames("".concat(FW_PREFIX, "__IlModalFooterV2-primary-button"), "".concat(FW_PREFIX, "__IlModalFooterV2-footer-button")),
        onClick: primaryButtonClick,
        kind: buttonKind,
        id: primaryButtonId,
        disabled: primaryButtonDisabled
      }, primaryButtonTooltipText ? /*#__PURE__*/React__default.createElement(IlTooltipTippy, {
        className: "".concat(FW_PREFIX, "__IlModalFooterV2-primary-button-tooltip"),
        placement: "top",
        appendTo: "parent",
        content: primaryButtonTooltipText
      }, /*#__PURE__*/React__default.createElement("span", null, primaryButtonText)) : primaryButtonText)), /*#__PURE__*/React__default.createElement("div", {
        className: classNames("".concat(modalFooterV2ClassName), "".concat(modalFooterV2ClassName, "-mobile"), "".concat(FW_PREFIX, "__IlModalFooterV2"))
      }, /*#__PURE__*/React__default.createElement(IlButton, {
        className: classNames("".concat(FW_PREFIX, "__IlModalFooterV2-primary-button"), "".concat(FW_PREFIX, "__IlModalFooterV2-footer-button")),
        onClick: primaryButtonClick,
        kind: buttonKind,
        id: primaryButtonId,
        size: "small"
      }, primaryButtonText), secondaryButtonText && /*#__PURE__*/React__default.createElement(IlButton, {
        className: classNames("".concat(FW_PREFIX, "__IlModalFooterV2-secondary-button"), "".concat(FW_PREFIX, "__IlModalFooterV2-footer-button")),
        onClick: secondaryButtonClick,
        kind: "secondary",
        id: secondaryButtonId
      }, secondaryButtonText), tertiaryButtonText && /*#__PURE__*/React__default.createElement(IlButton, {
        className: classNames("".concat(FW_PREFIX, "__IlModalFooterV2-tertiary-button"), "".concat(FW_PREFIX, "__IlModalFooterV2-footer-button")),
        onClick: tertiaryButtonClick,
        kind: "secondary",
        id: tertiaryButtonId
      }, tertiaryButtonText))));
    }
  }]);
}(Component);
IlModalFooterV2.propTypes = {
  modalFooterV2ClassName: PropTypes.string,
  danger: PropTypes.bool,
  primaryButtonText: PropTypes.string,
  primaryButtonId: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondaryButtonId: PropTypes.string,
  tertiaryButtonText: PropTypes.string,
  tertiaryButtonId: PropTypes.string,
  tertiaryButtonKind: PropTypes.oneOf(ButtonKinds),
  primaryButtonClick: PropTypes.func,
  primaryButtonDisabled: PropTypes.bool,
  secondaryButtonClick: PropTypes.func,
  secondaryButtonDisabled: PropTypes.bool,
  tertiaryButtonClick: PropTypes.func,
  tertiaryButtonDisabled: PropTypes.bool,
  primaryButtonTooltipText: PropTypes.string
};

export { IlModalFooterV2 };
